var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFavorite = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5141 17.3413C10.2307 17.4413 9.76406 17.4413 9.48073 17.3413C7.06406 16.5163 1.66406 13.0747 1.66406 7.24134C1.66406 4.66634 3.73906 2.58301 6.2974 2.58301C7.81406 2.58301 9.15573 3.31634 9.9974 4.44967C10.8391 3.31634 12.1891 2.58301 13.6974 2.58301C16.2557 2.58301 18.3307 4.66634 18.3307 7.24134C18.3307 13.0747 12.9307 16.5163 10.5141 17.3413Z",
    stroke: "#333335",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFavorite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/favorite.a771b156.svg";
export { ForwardRef as ReactComponent };